export default __webpack_public_path__ + "static/media/item2.eb165af6.jpg";